(function () {
        'use strict';

        angular
            .module('rms.common')
            .directive('rmsSchedulePicker', rmsOptionsSelector);

        function rmsOptionsSelector(lodash) {
            return {
                restrict: 'E',
                require: 'ngModel',
                scope: {
                    options: '=?',
                    validations: '=?',
                    refresh: '=?',
                    readonly: '=?',
                },
                controller: rmsSchedulePickerCtrl,
                controllerAs: 'vm',
                templateUrl: 'common/app/components/schedule-picker',
                link: function (scope, elem, attr, ctrl) {
                    scope.ngModelCtrl = ctrl;
                    var vm = scope.vm;

                    var dpObj = null;
                    var tpObj = null;
                    //
                    // scope.$watch(function() { return vm.scheduleActive}, function() {
                    //     if (vm.scheduleActive) {
                    dpObj = elem.find('input.date');
                    tpObj = elem.find('input.time');

                    dpObj.datepicker(vm.dateOption);
                    tpObj.timepicker(vm.timeOption);
                        // } else {
                    //         vm.dpObj.off();
                    //         vm.dbObj.datepicker('destroy');
                    //         vm.tpObj.off();
                    //         vm.tpObj.timepicker('destroy');
                    //         vm.dpObj = null;
                    //         vm.tpObj = null;
                    //     }
                    // });

                    ctrl.$formatters.push(function (modelValue) {
                        vm.repeatCount = lodash.get(modelValue, 'recurrence_repeat_count', 1);
                        vm.repeatFrequencyType = lodash.get(modelValue, 'recurrence_type', 1);
                        vm.selectedMonthDay = lodash.get(modelValue, 'recurrence_month_day', null);
                        vm.selectedWeekDays = lodash.get(modelValue, 'recurrence_week_days', []);
                        vm.startDate = lodash.get(modelValue, 'effective_from');
                        vm.startTime = lodash.get(modelValue, 'recurrence_time');
                        vm.selectedTimezone = lodash.get(modelValue, 'timezone_id');

                        vm.showDayOfMonth = vm.repeatFrequencyType == '3';
                        vm.showDayOfWeek = vm.repeatFrequencyType == '2';
                    });

                    ctrl.$render = function () {
                        // vm.updateNgModel();
                    };

                    scope.$watch(function() {
                        return vm.startDate +  vm.startTime;
                    }, function() {
                        vm.updateNgModel();
                    });
                }
            };
        }

        function rmsSchedulePickerCtrl($scope, lodash, $timeout) {
            var vm = this;
            this.$onInit = function() {
                //ng-models
                vm.repeatCount = undefined;
                vm.repeatFrequencyType = undefined;
                vm.selectedMonthDay = undefined;
                vm.scheduleActive = true; //default should be false, hardcode true to disable scheduling check
                vm.startDate = undefined;
                vm.startTime = undefined;
                vm.selectedWeekDays = [];
                vm.selectedTimezone = undefined;
                vm.moment_date_format = 'DD/MM/YYYY';
                vm.moment_time_format  = 'HH:mm:00';
                vm.picker_date_format = 'dd/mm/yyyy';
                vm.picker_time_format = 'h:mm a';

                //state
                // vm.showDayOfWeek = false;
                // vm.showDayOfMonth = false;

                //enums
                vm.monthDays = lodash.get($scope.options, 'enums.month_days', []);
                vm.weekDays = lodash.get($scope.options, 'enums.week_days', []);
                vm.repeatFrequencyOptions = lodash.get($scope.options, 'enums.repeat_frequency_type', []);
                vm.timezones = lodash.get($scope.options, 'enums.timezones', [])

                var lang =  angular.element('html').attr('lang');
                // replace this with kendo data source?
                vm.dateOption = {
                    // change: ƒ change()
                    // format: 'dd/MM/yyyy',
                    // min: new Date(Date.now()).toTimeString(),
                    //
                    // month: {
                    //     empty: '<div style="color:\\#ccc;line-height: 1.833em">#= data.value #</div>'
                    // }
                    language:lang,
                    startDate: moment().format(vm.moment_date_format),
                    format: vm.picker_date_format,
                    autoclose: true,
                    forceParse: false,
                }

                vm.timeOption =  angular.extend(
                    {
                        'showDuration': true,
                        'timeFormat': 'g:i A',
                        'language': lang,
                        // 'minTime': '2:00pm',
                    }
                    // lodash.get(scope, 'options', {})
                );

                vm.defaultSelectizeConfig = {
                    labelField: 'label',
                    valueField: 'value',
                    maxItems: 1,
                    persist: true,
                    create: false,
                    onIntialize: function (selectize) {
                    }
                }



                vm.updateNgModel = function () {
                    var modelValues = new ModelInstance();
                    $scope.ngModelCtrl.$setViewValue(modelValues);
                    // console.log('Model Changed: ', modelValues);
                }
            }

            function ModelInstance() {
                this.sch_effect_from = vm.startDate;
                this.sch_recurrence_time = vm.startTime;
                this.sch_recurrence_repeat_count = vm.repeatCount;
                this.sch_recurrence_type = vm.repeatFrequencyType;
                this.sch_recurrence_weekdays = vm.selectedWeekDays;
                this.sch_recurrence_month_day = vm.selectedMonthDay;
                this.sch_status = vm.scheduleActive;
                this.sch_timezone = vm.selectedTimezone;
            }

            vm.repeatFrequencyChange = function () {
                $timeout(function () {
                    vm.showDayOfWeek = false;
                    vm.showDayOfMonth = false;

                    switch (vm.repeatFrequencyType) {
                        case "2":
                            vm.showDayOfWeek = true;
                            break;
                        case "3":
                            vm.activeWeekday = 0;
                            vm.showDayOfMonth = true;
                            break;
                        default:
                            break;
                    }

                    vm.updateNgModel();
                })
            }

            vm.toggleIsActive = function (day) {
                return vm.selectedWeekDays.indexOf(day) !== -1;
            }

            vm.toggleWeekday = function (day) {
                $timeout(function () {
                    var selectedIndex = vm.selectedWeekDays.indexOf(day);
                    selectedIndex === -1 ? vm.selectedWeekDays.push(day) : lodash.pull(vm.selectedWeekDays, day);

                    vm.updateNgModel();
                })
            }
        }
    }

)();